"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeOneLayeredMap = exports.serializeOneLayeredMap = exports.deserializeTwoLayeredMap = exports.serializeTwoLayeredMap = exports.deserializeMap = exports.serializeMap = void 0;
const lodash_1 = __importDefault(require("lodash"));
const serializeMap = (map) => {
    return Array.from(map.entries());
};
exports.serializeMap = serializeMap;
const deserializeMap = (serializedMap) => {
    const map = new Map();
    for (const [key, value] of serializedMap) {
        map.set(key, value);
    }
    return map;
};
exports.deserializeMap = deserializeMap;
const serializeTwoLayeredMap = (twoLayeredMap) => {
    const clonedMap = lodash_1.default.cloneDeep(twoLayeredMap);
    for (const [topKey, topValue] of clonedMap.entries()) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        clonedMap.set(topKey, (0, exports.serializeOneLayeredMap)(topValue));
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return (0, exports.serializeOneLayeredMap)(clonedMap);
};
exports.serializeTwoLayeredMap = serializeTwoLayeredMap;
const deserializeTwoLayeredMap = (serializedTwoLayeredMap) => {
    if (!serializedTwoLayeredMap) {
        return new Map();
    }
    const rawDeserializedMap = JSON.parse(serializedTwoLayeredMap);
    for (const [index, [bottomKey, serializedBottomValue],] of rawDeserializedMap.entries()) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        rawDeserializedMap[index][1] = (0, exports.deserializeOneLayeredMap)(serializedBottomValue);
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return new Map(rawDeserializedMap);
};
exports.deserializeTwoLayeredMap = deserializeTwoLayeredMap;
const serializeOneLayeredMap = (map) => JSON.stringify(Array.from(map.entries()));
exports.serializeOneLayeredMap = serializeOneLayeredMap;
const deserializeOneLayeredMap = (serializedMap) => serializedMap ? new Map(JSON.parse(serializedMap)) : new Map();
exports.deserializeOneLayeredMap = deserializeOneLayeredMap;
//# sourceMappingURL=mapSerialization.js.map